import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Client } from '../../../global/types/Client';
import { ClientService } from '../../../global/services/client.service';

@Component({
  selector: 'app-clients-search',
  templateUrl: './clients-search.component.html',
  styleUrls: ['./clients-search.component.less'],
})
export class ClientSearchComponent {
  @Input() keyProperty: string;
  @Input() valueProperty: string;
  @Input() selectedItems: Client[] = [];
  @Input() extraParams: any = {};
  @Input() isSingleSelect: boolean;
  @Output() selectedItemsChanged = new EventEmitter<Client[]>();

  constructor(private clientService: ClientService) {}

  getClientsCallback(): (name: string) => Promise<Client[]> {
    return (name: string) => this.clientService.getClients({ name, ...this.extraParams });
  }

  onClientChange(selectedItems: Client[]): void {
    this.selectedItemsChanged.emit(selectedItems);
  }
}
